import {
	Component,
	OnInit,
	Input,
	OnDestroy,
	Output,
	EventEmitter,
	OnChanges,
	SimpleChanges,
	ViewEncapsulation
} from '@angular/core';
import { IdService } from '../../shared/services/id.service';
import { IProgressbarEvent, TProgressbarSize } from './progressbar.types';

@Component({
	selector: 'rbc-progressbar',
	templateUrl: './progressbar.component.html',
	styleUrls: ['./progressbar.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class ProgressbarComponent implements OnInit, OnDestroy, OnChanges {
	@Input() id: string;
	@Input() ariaDescribedBy: string;
	@Input() progress: string = '0%';
	@Input() round: boolean | string = false;
	@Input() size: TProgressbarSize = 'small';
	progressFill = '0%';

	@Output() progressbarupdate = new EventEmitter<IProgressbarEvent>();

	constructor(private idService: IdService) {
		this.id = this.idService.generate();
	}

	ngOnInit() {
		this.progressFill = this.progress;
		this.progressbarupdate.emit({ id: this.id, progress: this.progressFill, self: this });
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes && changes.progress && !changes.progress.firstChange) {
			this.progressFill = this.progress;
			this.progressbarupdate.emit({ id: this.id, progress: this.progressFill, self: this });
		}
	}

	ngOnDestroy(): void {
		if (this.idService) {
			this.idService.remove(this.id);
		}
	}
}
